import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Empty, Card, Col, Row } from 'antd';
import { CheckCircleTwoTone } from '@ant-design/icons';

import { exportConfigActions } from '../../redux/actions';

const SelectExportTemplate = ({ currentTemplate, setCurrentTemplate }) => {
    const dispatch = useDispatch();
    const fetchingExportConfigs = useSelector((state) => state.exportConfigs.fetchingExportConfigs);
    const exportConfigs = useSelector((state) => state.exportConfigs.exportConfigs);
    const isEmpty = !fetchingExportConfigs && exportConfigs && !Object.keys(exportConfigs).length;

    useEffect(() => {
        dispatch(exportConfigActions.fetchExportConfigs());
    }, [dispatch]);

    const renderContent = () => {
        if (exportConfigs == null) {
            return <></>;
        }

        return (
            <>
                {isEmpty ? (
                    <Empty
                        style={{
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                        }}
                    />
                ) : (
                    <div style={{ padding: '10px 0' }}>
                        <Row gutter={[16, 16]}>
                            {exportConfigs.map((template) => (
                                <Col key={template.export_config_id} span={6}>
                                    <Card
                                        hoverable
                                        title={template.name}
                                        extra={
                                            currentTemplate != null &&
                                            currentTemplate.export_config_id === template.export_config_id
                                                ? [
                                                      <CheckCircleTwoTone
                                                          key="checked"
                                                          style={{
                                                              fontSize: 'larger',
                                                          }}
                                                      />,
                                                  ]
                                                : null
                                        }
                                        onClick={() => setCurrentTemplate(template)}
                                    >
                                        <Card.Meta description={template.description} />
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    </div>
                )}
            </>
        );
    };
    return renderContent();
};

export default SelectExportTemplate;
